import { render, staticRenderFns } from "./GenreBlock.vue?vue&type=template&id=412a5299&scoped=true"
import script from "./GenreBlock.vue?vue&type=script&lang=ts"
export * from "./GenreBlock.vue?vue&type=script&lang=ts"
import style0 from "./GenreBlock.vue?vue&type=style&index=0&id=412a5299&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412a5299",
  null
  
)

export default component.exports